
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34329',
  depVersions: {
  "documents-public-ui": "static-1.34329",
  "client-types": "static-1.457",
  "documents-lib": "static-1.34334",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2058",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5523",
  "hs-test-utils": "static-1.7942",
  "hub-http": "static-1.6149",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11389",
  "I18n": "static-7.1607",
  "jasmine-immutable": "static-1.2947",
  "jasmine-runner": "static-1.6397",
  "lodash": "static-1.3",
  "quartz": "static-1.6921",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16588",
  "reporting-data": "static-1.67188",
  "reporting-testing-lib": "static-1.9121",
  "reporting-visualizations": "static-1.59264",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4698",
  "webpack-env": "static-1.54",
  "atom": "static-1.4999",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2423",
  "classnames": "static-2.10",
  "cssUtils": "static-1.775",
  "customer-data-filters-ui": "static-1.39496",
  "customer-data-objects": "static-1.7590",
  "customer-data-property-utils": "static-1.8012",
  "data-fetching-client": "static-1.9603",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4457",
  "flux-actions": "static-1.327",
  "FormsCommonComponents": "static-1.85647",
  "FormUrlGenerator": "static-2.4648",
  "foundations-components": "static-1.7788",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11697",
  "icons": "static-2.641",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7087",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3776",
  "property-translator": "static-1.5331",
  "quartz-config": "static-1.699",
  "quartz-core": "static-1.6140",
  "quick-fetch": "static-1.3861",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.103",
  "react-utils": "static-2.5287",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8097",
  "reference-resolvers-lite": "static-1.8020",
  "report-customization-components": "static-1.12913",
  "reporting-enablement": "static-1.22622",
  "reporting-reports": "static-1.66866",
  "reporting-snowflake": "static-1.55806",
  "reporting-ui-components": "static-2.64459",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4573",
  "sales-content-partitioning": "static-1.8865",
  "SalesContentIndexUI": "static-3.9136",
  "sanitize": "static-1.4401",
  "sanitize-text": "static-1.8073",
  "self-service-api": "static-1.10174",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1675",
  "signup-constants": "static-1.18720",
  "signup-ui-lego-core": "static-1.20730",
  "signup-ui-url-generator": "static-2.7964",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4697",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10919",
  "ui-addon-i18n": "static-1.11079",
  "ui-addon-react-router-dom": "static-1.9473",
  "ui-addon-upgrades": "static-9.17884",
  "ui-asset-management-lib": "static-1.10927",
  "ui-images": "static-2.1135",
  "UIComponents": "static-3.8336",
  "usage-tracker": "static-1.7265",
  "usage-tracker-container": "static-1.7255",
  "usage-tracker-core": "static-1.7115",
  "usage-tracker-public": "static-1.7076",
  "viral-links-lib": "static-1.6980",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3346",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3198",
  "quartz-webpack": "static-1.3145",
  "ai-components-ui-library": "static-1.8761",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4781",
  "foundations-theming": "static-1.4342",
  "quartz-auth": "static-1.596",
  "ui-business-units-lib": "static-1.8972",
  "usage-tracker-session-replay": "static-1.4951",
  "foundations-theming-base": "static-1.3327",
  "HeadJS": "static-2.738",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3053",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.27",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4253",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7854",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3534",
  "persist-promise": "static-1.3638",
  "quartz-i18n": "static-1.596",
  "reporting-client-types": "static-1.2446",
  "foundations-components-legacy": "static-1.813",
  "hs-story-utils": "static-1.9358",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9799",
  "hubspotter-http": "static-1.4595",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7179",
  "crm-message-bus": "static-1.42785",
  "customer-data-filters-ui-msw-helpers": "static-1.21931",
  "customer-data-objects-ui-components": "static-1.12950",
  "customer-data-reference-ui-components": "static-1.13084",
  "customer-data-ui-utilities": "static-1.9755",
  "framework-builder-read-service-client": "static-1.3953",
  "framework-data-schema-quick-fetch": "static-1.6709",
  "framework-data-schema-resolvers": "static-1.6804",
  "inbound-db-properties-service-client": "static-1.3785",
  "multi-account-reference-resolvers": "static-1.904",
  "onboarding-tours": "static-1.16465",
  "reporting-datasets-permissions-lib": "static-1.13459",
  "ui-addon-teams": "static-1.21454",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68142",
  "customer-data-properties": "static-1.51287",
  "forms-ai-lib": "static-1.4203",
  "forms-utils-lib": "static-1.12447",
  "foundations-components-test-utils": "static-1.5271",
  "react-dnd-compat": "static-1.4548",
  "react-tinymce": "static-1.55034",
  "tinymce-config": "static-2.54160",
  "ui-gdpr-components": "static-1.10276",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4057",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1607",
  "ui-fonts": "static-1.651",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.823",
  "mobile-manifest-mixins": "static-1.512",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.586",
  "quartz-routing": "static-1.351",
  "quartz-test": "static-1.596",
  "quartz-tracking": "static-1.300",
  "batch-promise": "static-1.1481",
  "external-options-client-types": "static-1.4102",
  "react-colorpicker": "static-2.10138",
  "copilot-toolkit": "static-1.10934",
  "data-quality-ui-library": "static-1.12689",
  "html-to-image": "static-1.52",
  "onboarding-scopes": "static-1.6393",
  "reporting-action-components": "static-1.41099",
  "reporting-filters": "static-1.131",
  "reporting-insights-lib": "static-1.1510",
  "reporting-plugins": "static-1.10177",
  "ui-addon-draggable-compat": "static-2.4183",
  "ui-addon-opt": "static-4.8309",
  "zustand": "static-1.72",
  "growth-payments-core": "static-1.25149",
  "hubspot-apollo-client": "static-1.4806",
  "chirp-fetch": "static-1.1811",
  "sales-templates-service-types-lib": "static-1.4111",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5751",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.4021",
  "nested-table": "static-1.155",
  "timezone-utils": "static-2.5172",
  "bender-build-tools": "static-1.3093",
  "chatspot-core": "static-1.20953",
  "bend-plugin-foundations-theming": "static-1.2825",
  "stylex": "static-1.31",
  "hubspotter-http-shared-msw-handlers": "static-1.9797",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3740",
  "crm-pipelines-api-client-types": "static-1.4086",
  "multi-currency-client-types": "static-1.3635",
  "getting-started-shared-tasks": "static-1.18292",
  "growth-data-modal": "static-1.5314",
  "growth-onboarding-confetti": "static-1.2998",
  "growth-onboarding-next-action-utils": "static-1.1699",
  "navigation-components": "static-1.17782",
  "onboarding-tours-client": "static-1.4679",
  "onboarding-tours-utils": "static-1.531",
  "ui-shepherd-react": "static-3.10077",
  "ui-shepherd-tracker": "static-1.7458",
  "ui-universal-auth": "static-1.8884",
  "user-context": "static-1.5029",
  "cms-field-types": "static-1.4738",
  "content-icons-ui": "static-1.2208",
  "integrations-lib": "static-1.15877",
  "calling-global-api": "static-1.64234",
  "calling-internal-common": "static-1.31231",
  "calling-lifecycle-internal": "static-1.65616",
  "calling-lifecycle-messages": "static-1.57910",
  "commerce-products-lib": "static-1.9252",
  "crm-links": "static-1.6208",
  "customer-data-properties-shared-msw-handlers": "static-1.9126",
  "file-manager-components": "static-1.23405",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.69",
  "inbounddb-objects-service-types": "static-1.4167",
  "meetings-icalendar-utils-lib": "static-1.559",
  "object-builder-ui-client": "static-1.48493",
  "pipeline-validation-client-types": "static-1.3909",
  "property-value-citations": "static-1.1901",
  "pulse": "static-1.476",
  "smart-property-lib": "static-1.6574",
  "tiered-pricing": "static-1.1057",
  "ui-addon-iframeable": "static-1.8980",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19708",
  "tinymce-themes": "static-1.56130",
  "data-token-picker": "static-1.16279",
  "hub-http-contrib": "static-1.2970",
  "interframe": "static-3.4691",
  "tinymce-data": "static-1.40245",
  "tinymce-plugins": "static-1.57274",
  "ui-addon-sales-email": "static-1.5140",
  "magpie-lib": "static-1.5515",
  "magpie-types": "static-1.4975",
  "simple-logging-lib": "static-1.2979",
  "content-assistance-lib": "static-1.7643",
  "dashboard-lib": "static-1.81241",
  "ExportDialog": "static-6.10320",
  "hubspot-prosemirror": "static-1.18024",
  "hubspot-prosemirror-plugins": "static-1.18016",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8625",
  "campaign-roi-lib": "static-1.8771",
  "feedback-loader": "static-1.29169",
  "apollo-link-hub-http": "static-2.4579",
  "hubspot-apollo-cache": "static-1.265",
  "nav-client-types": "static-1.2286",
  "purchase-motions-api": "static-1.5754",
  "trials-service-types": "static-1.3830",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.102",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1837",
  "growth-onboarding-next-action-components": "static-1.1727",
  "user-context-client": "static-1.4540",
  "idb-keyval": "static-1.42",
  "nest": "static-1.152",
  "reactive-lib": "static-1.651",
  "unified-auth-core-lib": "static-1.679",
  "getting-started-shared-tasks-store": "static-1.17410",
  "integrations-error-boundary-lib": "static-1.13292",
  "integrations-tracking-lib": "static-1.5525",
  "native-integrations-shared-strings": "static-1.7714",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10302",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.398",
  "calling-error-reporting": "static-1.31237",
  "shared-worker-versioning": "static-1.10966",
  "calling-usage-tracker": "static-1.6469",
  "voice-sms-access-library": "static-1.703",
  "customer-data-tracking": "static-1.6813",
  "commerce-permissions": "static-1.695",
  "products-iframe-lib": "static-1.7723",
  "products-ui-components-shared-msw-handlers": "static-1.10181",
  "location-customization-utils-lib": "static-1.9021",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4081",
  "video-components-external": "static-1.11037",
  "video-data-lib": "static-1.34695",
  "directed-graph": "static-1.866",
  "event-emitter": "static-1.876",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.79",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9882",
  "fsm": "static-1.3663",
  "policy-lib": "static-1.6712",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9945",
  "navigation-messaging": "static-1.7109",
  "FileManagerLib": "static-1.39045",
  "NamespacedHubStyle": "static-2.9008",
  "FileManagerCore": "static-1.38904",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12307",
  "layout-dnd-utils": "static-1.11282",
  "react-codemirror": "static-1.10552",
  "ui-addon-emoji-picker": "static-1.9815",
  "ui-brand-identity-lib": "static-1.14932",
  "ui-addon-video-player": "static-1.8625",
  "ui-coaching-tips": "static-1.28339",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8475",
  "payment-link-components": "static-1.23326",
  "EmailSignatureEditor": "static-1.24219",
  "InboxConnectUtils": "static-4.14606",
  "universal-page-editor-lib": "static-1.2937",
  "google-sheets-integration-lib": "static-1.23",
  "microsoft-drive-integration-lib": "static-1.113",
  "calling-orchestration-schema": "static-1.35480",
  "sales-views-client-types": "static-1.4191",
  "crm-record-cards-service-types": "static-1.3554",
  "content-media-composition-data-lib": "static-1.12013",
  "content-media-compositions": "static-2.16020",
  "media-bridge-lib": "static-1.18802",
  "trellis-story-utils": "static-1.4446",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5806",
  "FileManagerImages": "static-1.36556",
  "video-components": "static-1.13040",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4460",
  "video-embed": "static-1.35529",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68217",
  "layout-data-lib": "static-1.9607",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6511",
  "commerce-tours-lib": "static-1.5963",
  "growth-onboarding-reliability": "static-1.5012",
  "sales-checkout-service-client": "static-1.3569",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21547",
  "sales-email-signature-service-client": "static-1.3771",
  "social-insights-client-types": "static-1.21869",
  "outpost": "static-1.4118",
  "advanced-menus-core": "static-1.15017",
  "advanced-menus-lib": "static-1.11971",
  "ui-memberships-settings-lib": "static-1.33842",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15016",
  "simple-menus-lib": "static-1.16533"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34329",
  "client-types": "/client-types/static-1.457",
  "documents-lib": "/documents-lib/static-1.34334",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2058",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5523",
  "hs-test-utils": "/hs-test-utils/static-1.7942",
  "hub-http": "/hub-http/static-1.6149",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11389",
  "I18n": "/I18n/static-7.1607",
  "jasmine-immutable": "/jasmine-immutable/static-1.2947",
  "jasmine-runner": "/jasmine-runner/static-1.6397",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6921",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16588",
  "reporting-data": "/reporting-data/static-1.67188",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9121",
  "reporting-visualizations": "/reporting-visualizations/static-1.59264",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4698",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4999",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2423",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.775",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39496",
  "customer-data-objects": "/customer-data-objects/static-1.7590",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8012",
  "data-fetching-client": "/data-fetching-client/static-1.9603",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4457",
  "flux-actions": "/flux-actions/static-1.327",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85647",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4648",
  "foundations-components": "/foundations-components/static-1.7788",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11697",
  "icons": "/icons/static-2.641",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7087",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3776",
  "property-translator": "/property-translator/static-1.5331",
  "quartz-config": "/quartz-config/static-1.699",
  "quartz-core": "/quartz-core/static-1.6140",
  "quick-fetch": "/quick-fetch/static-1.3861",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-utils": "/react-utils/static-2.5287",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8097",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8020",
  "report-customization-components": "/report-customization-components/static-1.12913",
  "reporting-enablement": "/reporting-enablement/static-1.22622",
  "reporting-reports": "/reporting-reports/static-1.66866",
  "reporting-snowflake": "/reporting-snowflake/static-1.55806",
  "reporting-ui-components": "/reporting-ui-components/static-2.64459",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4573",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8865",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9136",
  "sanitize": "/sanitize/static-1.4401",
  "sanitize-text": "/sanitize-text/static-1.8073",
  "self-service-api": "/self-service-api/static-1.10174",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1675",
  "signup-constants": "/signup-constants/static-1.18720",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20730",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7964",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4697",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10919",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11079",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9473",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17884",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10927",
  "ui-images": "/ui-images/static-2.1135",
  "UIComponents": "/UIComponents/static-3.8336",
  "usage-tracker": "/usage-tracker/static-1.7265",
  "usage-tracker-container": "/usage-tracker-container/static-1.7255",
  "usage-tracker-core": "/usage-tracker-core/static-1.7115",
  "usage-tracker-public": "/usage-tracker-public/static-1.7076",
  "viral-links-lib": "/viral-links-lib/static-1.6980",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3346",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3198",
  "quartz-webpack": "/quartz-webpack/static-1.3145",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8761",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4781",
  "foundations-theming": "/foundations-theming/static-1.4342",
  "quartz-auth": "/quartz-auth/static-1.596",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8972",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4951",
  "foundations-theming-base": "/foundations-theming-base/static-1.3327",
  "HeadJS": "/HeadJS/static-2.738",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3053",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.27",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4253",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7854",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3534",
  "persist-promise": "/persist-promise/static-1.3638",
  "quartz-i18n": "/quartz-i18n/static-1.596",
  "reporting-client-types": "/reporting-client-types/static-1.2446",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.813",
  "hs-story-utils": "/hs-story-utils/static-1.9358",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9799",
  "hubspotter-http": "/hubspotter-http/static-1.4595",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7179",
  "crm-message-bus": "/crm-message-bus/static-1.42785",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21931",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12950",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13084",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9755",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3953",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6709",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6804",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3785",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.904",
  "onboarding-tours": "/onboarding-tours/static-1.16465",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13459",
  "ui-addon-teams": "/ui-addon-teams/static-1.21454",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68142",
  "customer-data-properties": "/customer-data-properties/static-1.51287",
  "forms-ai-lib": "/forms-ai-lib/static-1.4203",
  "forms-utils-lib": "/forms-utils-lib/static-1.12447",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5271",
  "react-dnd-compat": "/react-dnd-compat/static-1.4548",
  "react-tinymce": "/react-tinymce/static-1.55034",
  "tinymce-config": "/tinymce-config/static-2.54160",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10276",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4057",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1607",
  "ui-fonts": "/ui-fonts/static-1.651",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.823",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.512",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.586",
  "quartz-routing": "/quartz-routing/static-1.351",
  "quartz-test": "/quartz-test/static-1.596",
  "quartz-tracking": "/quartz-tracking/static-1.300",
  "batch-promise": "/batch-promise/static-1.1481",
  "external-options-client-types": "/external-options-client-types/static-1.4102",
  "react-colorpicker": "/react-colorpicker/static-2.10138",
  "copilot-toolkit": "/copilot-toolkit/static-1.10934",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12689",
  "html-to-image": "/html-to-image/static-1.52",
  "onboarding-scopes": "/onboarding-scopes/static-1.6393",
  "reporting-action-components": "/reporting-action-components/static-1.41099",
  "reporting-filters": "/reporting-filters/static-1.131",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1510",
  "reporting-plugins": "/reporting-plugins/static-1.10177",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4183",
  "ui-addon-opt": "/ui-addon-opt/static-4.8309",
  "zustand": "/zustand/static-1.72",
  "growth-payments-core": "/growth-payments-core/static-1.25149",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4806",
  "chirp-fetch": "/chirp-fetch/static-1.1811",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4111",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5751",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.4021",
  "nested-table": "/nested-table/static-1.155",
  "timezone-utils": "/timezone-utils/static-2.5172",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "chatspot-core": "/chatspot-core/static-1.20953",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2825",
  "stylex": "/stylex/static-1.31",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9797",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3740",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4086",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3635",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18292",
  "growth-data-modal": "/growth-data-modal/static-1.5314",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2998",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1699",
  "navigation-components": "/navigation-components/static-1.17782",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4679",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.531",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10077",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7458",
  "ui-universal-auth": "/ui-universal-auth/static-1.8884",
  "user-context": "/user-context/static-1.5029",
  "cms-field-types": "/cms-field-types/static-1.4738",
  "content-icons-ui": "/content-icons-ui/static-1.2208",
  "integrations-lib": "/integrations-lib/static-1.15877",
  "calling-global-api": "/calling-global-api/static-1.64234",
  "calling-internal-common": "/calling-internal-common/static-1.31231",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65616",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57910",
  "commerce-products-lib": "/commerce-products-lib/static-1.9252",
  "crm-links": "/crm-links/static-1.6208",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9126",
  "file-manager-components": "/file-manager-components/static-1.23405",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.69",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4167",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.559",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48493",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3909",
  "property-value-citations": "/property-value-citations/static-1.1901",
  "pulse": "/pulse/static-1.476",
  "smart-property-lib": "/smart-property-lib/static-1.6574",
  "tiered-pricing": "/tiered-pricing/static-1.1057",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8980",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19708",
  "tinymce-themes": "/tinymce-themes/static-1.56130",
  "data-token-picker": "/data-token-picker/static-1.16279",
  "hub-http-contrib": "/hub-http-contrib/static-1.2970",
  "interframe": "/interframe/static-3.4691",
  "tinymce-data": "/tinymce-data/static-1.40245",
  "tinymce-plugins": "/tinymce-plugins/static-1.57274",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5140",
  "magpie-lib": "/magpie-lib/static-1.5515",
  "magpie-types": "/magpie-types/static-1.4975",
  "simple-logging-lib": "/simple-logging-lib/static-1.2979",
  "content-assistance-lib": "/content-assistance-lib/static-1.7643",
  "dashboard-lib": "/dashboard-lib/static-1.81241",
  "ExportDialog": "/ExportDialog/static-6.10320",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18024",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18016",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8625",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8771",
  "feedback-loader": "/feedback-loader/static-1.29169",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4579",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.265",
  "nav-client-types": "/nav-client-types/static-1.2286",
  "purchase-motions-api": "/purchase-motions-api/static-1.5754",
  "trials-service-types": "/trials-service-types/static-1.3830",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.102",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1837",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1727",
  "user-context-client": "/user-context-client/static-1.4540",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.152",
  "reactive-lib": "/reactive-lib/static-1.651",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.679",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17410",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13292",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5525",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7714",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10302",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.398",
  "calling-error-reporting": "/calling-error-reporting/static-1.31237",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10966",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6469",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.703",
  "customer-data-tracking": "/customer-data-tracking/static-1.6813",
  "commerce-permissions": "/commerce-permissions/static-1.695",
  "products-iframe-lib": "/products-iframe-lib/static-1.7723",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10181",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9021",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4081",
  "video-components-external": "/video-components-external/static-1.11037",
  "video-data-lib": "/video-data-lib/static-1.34695",
  "directed-graph": "/directed-graph/static-1.866",
  "event-emitter": "/event-emitter/static-1.876",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.79",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9882",
  "fsm": "/fsm/static-1.3663",
  "policy-lib": "/policy-lib/static-1.6712",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9945",
  "navigation-messaging": "/navigation-messaging/static-1.7109",
  "FileManagerLib": "/FileManagerLib/static-1.39045",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9008",
  "FileManagerCore": "/FileManagerCore/static-1.38904",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12307",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11282",
  "react-codemirror": "/react-codemirror/static-1.10552",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9815",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14932",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8625",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28339",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8475",
  "payment-link-components": "/payment-link-components/static-1.23326",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24219",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14606",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2937",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.23",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.113",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35480",
  "sales-views-client-types": "/sales-views-client-types/static-1.4191",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3554",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12013",
  "content-media-compositions": "/content-media-compositions/static-2.16020",
  "media-bridge-lib": "/media-bridge-lib/static-1.18802",
  "trellis-story-utils": "/trellis-story-utils/static-1.4446",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5806",
  "FileManagerImages": "/FileManagerImages/static-1.36556",
  "video-components": "/video-components/static-1.13040",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4460",
  "video-embed": "/video-embed/static-1.35529",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68217",
  "layout-data-lib": "/layout-data-lib/static-1.9607",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6511",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5963",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5012",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21547",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3771",
  "social-insights-client-types": "/social-insights-client-types/static-1.21869",
  "outpost": "/outpost/static-1.4118",
  "advanced-menus-core": "/advanced-menus-core/static-1.15017",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11971",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33842",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15016",
  "simple-menus-lib": "/simple-menus-lib/static-1.16533"
}
};
